
import React, { useEffect, useState } from 'react';
import { CartesianGrid, Line, LineChart, XAxis, YAxis, Tooltip, PieChart, Pie, Legend, BarChart, Bar, ComposedChart, Area } from 'recharts';
import './Dashboard.css';
const Dashboard = () => {
    const [charts, setCharts] = useState([]);
    useEffect(() => {
        fetch('chart-data.json')
            .then(res => res.json())
            .then(data => setCharts(data))
    }, []);
    const data = [...charts];
    return (
        <div className='chart'>
            <h4> Dashboard</h4>
            <div className='chart-container'>
                <div className='linechart'>
                    <LineChart width={300} height={300} data={data}>
                        <XAxis dataKey="month" />
                        <YAxis />
                        <Tooltip></Tooltip>
                        <Legend verticalAlign="top" height={36} />
                        <CartesianGrid stroke="#eee" strokeDasharray="5 5" />
                        <Line type="monotone" dataKey="sell" stroke="#82ca9d" />
                    </LineChart>
                </div>
                <div className='linechart'>
                    <PieChart width={300} height={250}>
                        <Pie data={data} dataKey="sell" nameKey="sell" cx="50%" cy="50%" outerRadius={50} fill="#8884d8" />
                        <Pie data={data} dataKey="investment" nameKey="investment" cx="50%" cy="50%" innerRadius={60} outerRadius={80} fill="#82ca9d" label />
                    </PieChart>
                </div>
                <div className='linechart'>
                    <BarChart width={300} height={250} data={data}>
                        <CartesianGrid strokeDasharray="3 3" />
                        <XAxis dataKey="month" />
                        <YAxis />
                        <Tooltip />
                        <Legend />
                        <Bar dataKey="investment" fill="#8884d8" />
                        <Bar dataKey="revenue" fill="#82ca9d" />
                    </BarChart>
                </div>

                <div className='linechart'>
                    <ComposedChart width={300} height={250} data={data}>
                        <XAxis dataKey="month" />
                        <YAxis />
                        <Tooltip />
                        <Legend />
                        <CartesianGrid stroke="#f5f5f5" />
                        <Area type="monotone" dataKey="revenue" fill="#8884d8" stroke="#8884d8" />
                        <Bar dataKey="investment" barSize={20} fill="#413ea0" />
                        <Line type="monotone" dataKey="sell" stroke="#ff7300" />
                    </ComposedChart>
                </div>




            </div>

        </div>
    );
};

export default Dashboard;